import { useMemo, useState } from 'react';
import { categoryTabs, feedItems } from '@/mocks/hotNews';

export default function Feed() {
  const [category, setCategory] = useState('全部');
  const [keyword, setKeyword] = useState('');
  const [visible, setVisible] = useState(4);

  const filtered = useMemo(() => {
    const kw = keyword.trim().toLowerCase();
    return feedItems.filter((it) => {
      const okTag = category === '全部' || it.tag === category;
      const okKw = !kw || it.title.toLowerCase().includes(kw) || it.summary.toLowerCase().includes(kw) || it.tag.toLowerCase().includes(kw);
      return okTag && okKw;
    });
  }, [category, keyword]);

  const shown = filtered.slice(0, visible);

  const reset = () => {
    setCategory('全部');
    setKeyword('');
    setVisible(4);
  };

  return (
    <section id="feed" className="w-full scroll-mt-24 bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-5 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-bubble-chart-line" aria-hidden="true" /> FRESH GOSSIP
            </p>
            <h2 className="mt-2 font-display text-2xl font-black md:text-3xl">瓜田速递 · 今日份新鲜瓜</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">按标签筛选或直接搜索你关心的瓜，随时在线围观全网热议焦点。</p>
          </div>

          <label className="flex w-full max-w-xs items-center gap-2 rounded-full border border-background-200 bg-background-50 px-4 py-2.5 focus-within:border-primary-400">
            <i className="ri-search-line text-sm text-foreground-400" aria-hidden="true" />
            <input
              value={keyword}
              onChange={(e) => {
                setKeyword(e.target.value);
                setVisible(4);
              }}
              type="search"
              placeholder="搜个瓜看看…"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            {keyword && (
              <button type="button" onClick={() => setKeyword('')} aria-label="清空搜索" className="cursor-pointer text-foreground-400 hover:text-foreground-600">
                <i className="ri-close-circle-fill" />
              </button>
            )}
          </label>
        </div>

        {/* category tabs */}
        <div className="mt-6 flex flex-wrap items-center gap-2">
          {categoryTabs.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => {
                setCategory(c);
                setVisible(4);
              }}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${category === c ? 'bg-primary-500 text-background-50' : 'bg-background-50 text-foreground-600 hover:text-primary-700'}`}
            >
              {c}
            </button>
          ))}
        </div>

        {/* list */}
        {shown.length > 0 ? (
          <div className="mt-7 grid gap-5 lg:grid-cols-2">
            {shown.map((it) => (
              <article key={it.id} className="flex flex-col gap-4 rounded-2xl bg-background-50 p-3 transition-colors hover:bg-background-200/60 sm:flex-row">
                <div className="aspect-[16/9] w-full shrink-0 overflow-hidden rounded-xl sm:aspect-auto sm:w-44">
                  <img src={it.image} alt={it.title} className="h-full w-full object-cover object-top" />
                </div>
                <div className="flex flex-1 flex-col py-1 pr-1">
                  <div className="flex items-center gap-2">
                    <span className="whitespace-nowrap rounded-md bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">{it.tag}</span>
                    <span className="whitespace-nowrap text-xs text-foreground-400">{it.time}</span>
                  </div>
                  <h3 className="mt-2 line-clamp-2 font-display text-base font-bold leading-6 text-foreground-950 hover:text-primary-700">{it.title}</h3>
                  <p className="mt-1.5 line-clamp-2 text-sm leading-6 text-foreground-600">{it.summary}</p>
                  <div className="mt-auto flex items-center gap-3 pt-2 text-xs text-foreground-400">
                    <span className="flex items-center gap-1"><i className="ri-eye-line" aria-hidden="true" />{it.views}</span>
                    <span className="flex items-center gap-1"><i className="ri-chat-3-line" aria-hidden="true" />{it.comments}</span>
                    <span className="flex items-center gap-1"><i className="ri-time-line" aria-hidden="true" />{it.read}阅读</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-10 flex flex-col items-center rounded-2xl bg-background-50 px-6 py-14 text-center">
            <i className="text-4xl text-foreground-300 ri-folder-forbid-line" aria-hidden="true" />
            <p className="mt-3 font-display text-base font-bold">这片瓜田暂时没有你要找的瓜</p>
            <p className="mt-1 text-sm text-foreground-500">换个关键词或分类试试，说不定下一颗就是你要的。</p>
            <button type="button" onClick={reset} className="mt-5 flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 hover:bg-primary-600">
              <i className="ri-restart-line" aria-hidden="true" /> 重置筛选
            </button>
          </div>
        )}

        {visible < filtered.length && (
          <div className="mt-8 text-center">
            <button type="button" onClick={() => setVisible((v) => v + 2)} className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-medium text-foreground-700 hover:border-primary-400 hover:text-primary-700">
              <i className="ri-add-line" aria-hidden="true" /> 再加载 2 条速报
            </button>
          </div>
        )}
      </div>
    </section>
  );
}